// extracted by mini-css-extract-plugin
module.exports = {"card":"editSubscription_card__27bdm","title":"editSubscription_title__UqRB2","description":"editSubscription_description__380-7","actions":"editSubscription_actions__pVdJK"};